import { Autocomplete } from 'components/v2/Autocomplete'
import { useQuery, gql } from '@apollo/client'
import { GTLoyaltyRewardAutocomplete, GTQuery } from 'gql/types.generated'
import { ReactElement } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { IRewardAutocompleteProps } from './types'
import { IReward } from 'features/Loyalty/types'

const messages = defineMessages({
  error: {
    id: 'selectRewardsAutocomplete.error',
    defaultMessage: 'There was an error loading rewards'
  },
  empty: {
    id: 'selectRewardsAutocomplete.empty',
    defaultMessage: 'No rewards found'
  }
})
const GET_REWARDS_AUTOCOMPLETE = gql`
  query getRewardsAutocomplete($companyID: ID) {
    loyaltyRewardsAutocomplete(input: { companyID: $companyID }) {
      id
      name
    }
  }
`

export const RewardAutocomplete = ({ onSelectReward, companyId, ...props }: IRewardAutocompleteProps): ReactElement => {
  const intl = useIntl()
  const { data, loading, error } = useQuery<Pick<GTQuery, 'loyaltyRewardsAutocomplete'>>(GET_REWARDS_AUTOCOMPLETE, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
    variables: {
      companyID: companyId
    }
  })
  const shownItems = data?.loyaltyRewardsAutocomplete ?? []
  const handleChange = (reward: IReward): void => {
    onSelectReward(reward)
  }
  const getRewardLabel = (reward: GTLoyaltyRewardAutocomplete): string => {
    if (reward && reward.id) {
      return `${reward.name}`
    }
    return ''
  }
  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(reward: GTLoyaltyRewardAutocomplete): string => getRewardLabel(reward)}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
